import {event, selectDoc, selectArr, toggleClassAll, toggleClass, ajax} from "../utils/utils";
import {inputEmail, inputEmpty, inputPassword} from "../helpers/service.validator";

const props = {
    subjectSelect: selectDoc('select[name="contact[subject]"]'),
    subjectDd: selectDoc('#ContactForm #subject-dropdown'),
    subjectDdArrow: selectDoc('#subject-dropdown .arrow-icon'),
    subjectDdCurrent: selectDoc('#subject-dropdown .chosen-option'),
    subjectOpts: selectArr(('#ContactForm .dropdown-opt')),


    contactForm: selectDoc('#ContactForm'),
    contactSubmit: selectDoc('#ContactForm button.btn'),
    contactResponse: selectDoc('#ContactForm .success-response'),
    contactEmail: selectDoc('#ContactForm #ContactForm-email'),
    contactName: selectDoc('#ContactForm #ContactForm-name'),
    contactPhone: selectDoc('#ContactForm #ContactForm-phone'),
    contactBody: selectDoc('#ContactForm #ContactForm-message'),
    contactSubject: selectDoc('#ContactForm #Subject'),
    responseContainer: selectDoc('#ws-template-one .response-container'),
    gValue: '',
    authKey: '',
}

const ajaxContactCall = (button, inputs = [], requestData = {}, endpoint = '', captchaContainer, successContainer) => {
    button.disabled = true;
    button.style.opacity = '0.5';
    let error = false;


    inputs.map(input => {
        if (input) {
            let inputMsg = selectDoc('.' + input.id + '.error-input')

        

            /**
             * Clean error
             */
            input.classList.remove('error')
            inputMsg.classList.remove('show')
            inputMsg.innerText = ''


            /**
             * Validate empty
             */
            if (inputEmpty(input.value)) {
                error = true;
                input.classList.add('error')

                inputMsg.innerText = "Field can't be empty."
                inputMsg.classList.add('show')
                $(input).focus();
            } else {
                /**
                 * Validate email
                 */
                if (input.id.includes('Email') || input.id.includes('email')) {
                    if (!inputEmail(input.value)) {
                        error = true;
                        input.classList.add('error')

                        inputMsg.innerText = "Please enter a valid email address."
                        inputMsg.classList.add('show')
                    }
                }

                /**
                 * Validate password
                 */
                if (input.id.includes('password') || input.id.includes('Password')) {
                    if (!inputPassword(input.value)) {
                        error = true;
                        input.classList.add('error')

                        inputMsg.innerText = "Please enter a valid password."
                        inputMsg.classList.add('show')
                    }
                }
            }
        }
    });

    if (!error) {
        /**
         * Check if captcha params required
         */
        if (props.authKey && props.gValue) {
            requestData = {
                "authenticity_token": props.authKey,
                "g-recaptcha-response": props.gValue,
            }
        }

        /**
         * Prepare request data
         */
        let formBody = []
        for (var property in requestData) {
            if (requestData[property] != '') {
                var encodedKey = encodeURIComponent(property);
                var encodedValue = encodeURIComponent(requestData[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }
        }

        /**
         * Make call
         */
        ajax('POST',
            endpoint,
            formBody.join('&'),
            'application/x-www-form-urlencoded'
        ).then(function (response) {
            button.disabled = false;
            button.style.opacity = '1';
            response = JSON.parse(response).response;

            /**
             * If Captcha present on HTML response
             */
            if (response.includes('shopify-challenge__container')) {

                /**
                 * Render response
                 */
                props.responseContainer.innerHTML = response;

                /**
                 * Extract auth keys
                 */
                props.authKey = (selectDoc("input[name='authenticity_token']").value);

                let siteKey = '';
                selectArr(("script")).map(script => {
                    if (script.innerHTML.includes('recaptchaCallback')) {
                        script.innerHTML.split(':').map(portion => {
                            if (portion.includes('size')) {
                                siteKey = portion.split(',')[0]
                            }
                        })
                    }
                })

                /**
                 * Clean response
                 */
                props.responseContainer.innerHTML = ''

                /**
                 * Render captcha
                 */
                let scriptTag = document.createElement('script'),
                    scriptTagTwo = document.createElement('script');

                scriptTagTwo.innerHTML = `
                        var onCaptchaSuccessCustom = function () {
                            var event;
                            try {
                                event = new Event('captchaSuccessCustom', {bubbles: true, cancelable: true});
                            } catch (e) {
                                event = document.createEvent('Event');
                                event.initEvent('captchaSuccessCustom', true, true);
                            }
                            window.dispatchEvent(event);
                        }
                        
                        var recaptchaCallbackCustom = function () {
                            let widgetId = grecaptcha.render('${captchaContainer}', {
                                sitekey: ${siteKey},
                                size: (window.innerWidth > 320) ? 'normal' : 'compact',
                                callback: 'onCaptchaSuccessCustom',
                            })
                        ;};
                        `
                props.responseContainer.appendChild(scriptTagTwo)

                scriptTag.src = 'https://www.recaptcha.net/recaptcha/api.js?onload=recaptchaCallbackCustom&amp;render=explicit&amp;hl=en';
                props.responseContainer.appendChild(scriptTag)

                /**
                 * Listen response
                 */
                window.addEventListener('captchaSuccessCustom', function () {
                    let responseInput = document.querySelector('.g-recaptcha-response');
                    props.gValue = responseInput.value
                }, false);

            } else {
                props.gValue = '';
                props.authKey = '';

                props.responseContainer.innerHTML = response;
                let success = selectDoc(successContainer)
                props.responseContainer.innerHTML = '';

                if (success) {
                    selectDoc('#' + captchaContainer).innerHTML = ''
                    props.contactResponse.innerText = success.innerText

                    setTimeout(function () {
                        button.classList.add('success');
                        button.innerText = 'Submitted';
                        let successmsg = selectDoc('.success-msg');
                        if(successmsg){
                            successmsg.classList.add('show')
                        }
                        // setTimeout(function () {
                        //     location.reload();
                        // }, 3000)
                    }, 1000)

                }
            }
        });
    } else {
        button.disabled = false;
        button.style.opacity = '1';
    }
}

const initContactForm = () => {
    if (props.contactSubmit) {
        let now = new Date();
        event(props.contactSubmit, 'click', function (e) {
            e.preventDefault()
            ajaxContactCall(
                props.contactSubmit,
                [props.contactName, props.contactEmail, props.contactPhone, props.contactSubject, props.contactBody].reverse(),
                {
                    "contact[Date]": `${(now.getMonth() + 1)}/${now.getDate()}/${now.getFullYear()}`,
                    "contact[Case]": props.contactSubject.value,
                    "contact[Name]": props.contactName.value,
                    "contact[email]": props.contactEmail.value,
                    "contact[Phone Number]": props.contactPhone.value,
                    "contact[Message]": props.contactBody.value,
                    "form_type": 'contact',
                    "utf8": '✓'
                },
                "/contact",
                'g-recaptcha-contact',
                '#ContactForm .form-message--success',
                '')
        })
    }
}

const initDropdown = async () => {
    event(props.subjectDd, 'click', function () {
        toggleClassAll(props.subjectOpts, 'show')
        toggleClass(props.subjectDdArrow, 'open')
    })

    let top = 20;
    props.subjectOpts.map(opt => {
        top += 75;
        opt.style.top = top + 'px'

        event(opt, 'click', function () {
            props.subjectDdCurrent.innerText = opt.innerText
            props.subjectSelect.selectedIndex = opt.getAttribute('data-opt')

            toggleClass(props.subjectDdArrow, 'open')
            toggleClassAll(props.subjectOpts, 'show')
        })
    })
}

const initializer = () => {
    initDropdown()
    initContactForm()
}

export const Contact = {
    init: () => initializer()
}
